import { render, staticRenderFns } from "./ProductsDataV3.vue?vue&type=template&id=5b1d8d85&"
import script from "./ProductsDataV3.vue?vue&type=script&lang=js&"
export * from "./ProductsDataV3.vue?vue&type=script&lang=js&"
import style0 from "./ProductsDataV3.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/zp_frontend_vuejs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5b1d8d85')) {
      api.createRecord('5b1d8d85', component.options)
    } else {
      api.reload('5b1d8d85', component.options)
    }
    module.hot.accept("./ProductsDataV3.vue?vue&type=template&id=5b1d8d85&", function () {
      api.rerender('5b1d8d85', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/ProductsDataV3.vue"
export default component.exports